import { Injectable, inject } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PageLoadingService {
  private router = inject(Router);

  private readonly SPINNER_DELAY_MS = 1000;
  private loadingTimer: number | null = null;
  private _isContentPageLoading = true;

  get isContentPageLoading(): boolean {
    return this._isContentPageLoading;
  }

  set isContentPageLoading(value: boolean) {
    if (value) {
      if (this.loadingTimer !== null) {
        clearTimeout(this.loadingTimer);
      }
      this.loadingTimer = window.setTimeout(() => {
        this._isContentPageLoading = true;
      }, this.SPINNER_DELAY_MS);
    } else {
      if (this.loadingTimer !== null) {
        clearTimeout(this.loadingTimer);
        this.loadingTimer = null;
      }
      this._isContentPageLoading = false;
    }
  }

  constructor() {
    // Forcibly disable page loading if user navigates to a new page
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.loadingTimer !== null) {
          clearTimeout(this.loadingTimer);
          this.loadingTimer = null;
        }
        this._isContentPageLoading = false;
      }
    });
  }
}
